import { useEffect, useRef, useState } from "react";
import WriteAddPictureIcon from "assets/community_assets/write/write_image_add_icon.svg";
import OnlyConfirmDialog from "components/onlyConfirm_dialog";


/// ✅ MAX사이즈
const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export default function WriteAddImageSlider({ images, setImages }) {
    const inputRef = useRef(null);

    /// ✅ 확인모달 관련
    const [onlyConfirmModal, setOnlyConfirmModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");

    // ✅ 이미지 추가 핸들러
    const handleImageAdd = (e) => {
        if (images.length >= 5) {
            setOnlyConfirmModal(true);
            setModalMessage("5장이상 업로드 하실 수 없습니다.")
            return;
        }

        const files = Array.from(e.target.files);
        const imageUrls = files.map((file) => URL.createObjectURL(file));

        /// ✅ file이 아니면 return
        if (!(files[0] instanceof File)) {
            return;
        }

        if (files[0].size > MAX_FILE_SIZE) {
            setOnlyConfirmModal(true);
            setModalMessage("사진 용량이 10MB를 초과했습니다.")
            return;
        }

        const body = { // map으로 변환
            file: files,
            url: imageUrls
        }

        setImages((prev) => [...prev, body]);
    };

    /// ✅ 이미지 제거
    const handleDelete = (indexToDelete) => {
        setImages((prev) => prev.filter((_, idx) => idx !== indexToDelete));
    };

    return (
        <>
            {/* 숨겨진 파일 선택 input */}
            <input
                type="file"
                accept="image/png, image/jpeg"
                multiple={false} // 여러개 선택 불가
                ref={inputRef}
                onChange={handleImageAdd}
                style={{ display: "none" }}
            />

            {/* 이미지 슬라이더 */}
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    overflowX: "auto", // ✅ 넘칠 때만 스크롤 표시
                    gap: "12px",
                    scrollbarWidth: "auto", // Firefox
                }}
                className="image-scroll-container"
            >
                {/* 사진 추가 버튼 */}
                <img
                    src={WriteAddPictureIcon}
                    onClick={() => inputRef.current?.click()}
                    style={{ cursor: "pointer", minWidth: "118px", minHeight: "118px" }}
                />

                {/* 이미지 미리보기 */}
                {Array.from({ length: 5 }).map((_, index) =>
                    images[index] ? (
                        <div
                            key={index}
                            style={{
                                position: "relative",
                                minWidth: "118px",
                                minHeight: "118px",
                                maxWidth: "118px",
                                maxHeight: "118px",
                                borderRadius: "8px",
                                overflow: "hidden",
                                backgroundColor: "#F3F4F6",
                            }}
                        >
                            <img
                                src={images[index].url ?? images[index]} // 추가한이미지 ?? 파베이미지 url
                                draggable={false}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                }}
                            />

                            {/* X 버튼 */}
                            <div
                                onClick={() => handleDelete(index)}
                                style={{
                                    position: "absolute",
                                    top: "4px",
                                    right: "4px",
                                    backgroundColor: "rgba(0,0,0,0.6)",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "20px",
                                    height: "20px",
                                    fontSize: "14px",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    cursor: "pointer",
                                    zIndex: 1,
                                }}
                            >
                                ×
                            </div>
                        </div>
                    ) : (
                        <div
                            key={index}
                            style={{
                                minWidth: "118px",
                                minHeight: "118px",
                                borderRadius: "8px",
                                backgroundColor: "#F3F4F6",
                            }}
                        />
                    )
                )}
                <OnlyConfirmDialog
                    open={onlyConfirmModal}
                    onClose={() => setOnlyConfirmModal(false)}
                    message={modalMessage}
                />
            </div>
        </>
    );
}
